import type { FaireProductEntity } from "../../entity_types/product";

export const p_2vlegx1g3s: FaireProductEntity = {
  token: "p_2vlegx1g3s",
  type: "product",
  name: "Award Winning Bacon Jam - Best Burger Sauce",
  brandToken: "b_2jx35qq7q6",
  brandName: "Midwest Fresh",
  imageUrl:
    "https://cdn.faire.com/fastly/808460a00a88e7256ebaa8f494a6344f904f097b30da9ed2f905a280b518b4ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eeaa1faf5368eb6bee2d2715a1709aaf15a14591825e477d34335f7d746c305e.jpeg",
    "https://cdn.faire.com/fastly/93a0a887e9cc7ca5caf329a7253dae10046c2a5a3272aa17a0b0b3c6c57a6241.jpeg",
    "https://cdn.faire.com/fastly/d671d930ac6f29473a75b0adf2c4ad6b49565d1097b538b564c04fecda6aef93.jpeg",
    "https://cdn.faire.com/fastly/21094828daaa4831455e573970a076f5f767776c1be2b23d51d78a1a16e607ae.jpeg",
    "https://cdn.faire.com/fastly/473ea80ef42350e40d09a14820247e0eff2fb28b70f53e0a2b18a65183422b6f.jpeg",
    "https://cdn.faire.com/fastly/c1356f1ceb485ea6d3ecb796ed40b2906a537cafe3d72e418642df1e8fc78ba7.jpeg",
    "https://cdn.faire.com/fastly/bb8d99cb7bc4174fa1669560f0f01bd49aab67e58bbaf84981228cd6cee98e0b.jpeg",
    "https://cdn.faire.com/fastly/66f13b6ad7f2ac9cd112848f65687ee93ed61fd5427958e6e553e5fa67e8fd7d.jpeg",
    "https://cdn.faire.com/fastly/7c2a977057e29e81778c2c3b1772fb7a3f083ff3f4d82e7a145311c946c8b6f9.jpeg",
    "https://cdn.faire.com/fastly/73c360db5fb1f792507b5b78271d5e82465a3ea0c99a0071b539f479f51a8a2f.png",
    "https://cdn.faire.com/fastly/2bcd10a3b349ee9eb9e7a92112e5827221c01bb72baf5c76c35a844d53badbf4.jpeg",
  ],
  priceDollars: 7.1,
  description:
    "Award winning Best Burger Sauce. Originally created for a restaurant hamburger topping, Bacon Jam has grown into the headliner for Midwest Fresh. A gooey bacon and onion marmalade/relish, that has more uses than we know about.\n\n• think off the grill. Bratwurst, cheese burgers, grilled fish, sauteed vegetables, easy to make into a crust or topping, and great as a dip. This is the best burger sauce in Indiana and the Midwest. Also used for Bloody Mary’s and recently renowned for use on Charcutterie boards. Will be the spotlight at any gathering or grill party.\n\n• 2019 LUX Life Best Burger Sauce\n• 2019 LUX Life Leading Artisan Purveyor\n• 2020 GOOD FOOD Awards Finalist",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:06.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
